import CategoriesService from './CategoriesService';

export {default} from './CategoriesService';
export const categoriesService = new CategoriesService();